import React from 'react';
import QuizFunnel from './components/QuizFunnel';

function App() {
  return (
    <div className="antialiased text-gray-900">
      <QuizFunnel />
    </div>
  );
}

export default App;